module.exports = __webpack_public_path__ + "img/organizing-icon.d57b89b0.png";